export const COOKIE_MODAL_EVENTS = {
  MAIN: 'cookieModal',
  SET_VALUES: 'cookieModal.values',
};
